import { at, set as objectSet } from '@lsfe/tools';

const uuidv1 = require('uuid/v1');

// 安全获取多层对象的属性
const objectAt = (obj, path) => {
    let res = at(obj, path);
    if (!Array.isArray(path) && Array.isArray(res)) {
        res = res[0];
    }
    return res;
};

/**
 * 将扁平数组转换为标准树对象
 * @param array
 * @param options
 * @param isClean
 * */
const arrayToTree = function(arr = [], options = {}) {
    if (!arr || !arr.length) {
        return [];
    }
    const arrData = arr.map(item => {
        let obj = {};
        let isClean = false;
        for (let [key, value] of Object.entries(options)) {
            obj[key] = item[value];
            isClean = true;
        }
        let itemObj = {};
        if (isClean) {
            let { id, parentId, children } = item;
            itemObj = { id, parentId, children };
        } else {
            itemObj = item;
        }
        return Object.assign({}, itemObj, obj);
    });

    let tree = [],
        mappedArr = {},
        arrElem,
        mappedElem;

    // 创建数组和map对象，保存每个节点的引用
    for (let i = 0, len = arrData.length; i < len; i++) {
        arrElem = arrData[i];
        mappedArr[arrElem.id] = arrElem;
    }

    for (let id in mappedArr) {
        if (mappedArr.hasOwnProperty(id)) {
            mappedElem = mappedArr[id];
            // 如果元素不在根节点，则把它放到其父节点中
            if (mappedElem['parentId']) {
                const parent = mappedArr[mappedElem['parentId']];
                if (!parent) {
                    continue;
                }
                if (!parent['children']) {
                    parent['children'] = [];
                }
                parent['children'].push(mappedElem);
            } else {
                // 如果元素在根结点，把它直接添加到第一层。
                tree.push(mappedElem);
            }
        }
    }
    return tree;
};

const getUuid = function() {
    return uuidv1();
};

export const isEqualArray = (arr1, arr2) => {
    if (!arr1 && !arr2) {
        return true;
    }
    if (arr1.length !== arr2.length) {
        return false;
    }
    return arr1.every((item, index) => {
        return arr1[index] === arr2[index];
    });
};

export const isEqual = (val1, val2, deepObj = false) => {
    const typeVal1 = Object.prototype.toString.call(val1);
    const typeVal2 = Object.prototype.toString.call(val2);
    if (typeVal1 !== typeVal2) {
        return false;
    }
    if (Array.isArray(val1)) {
        return isEqualArray(val1, val2);
    }
    if (deepObj && typeVal1 === '[object Object]') {
        return Object.keys(val1).every(key => isEqual(val1[key], val2[key], deepObj));
    }
    return val1 === val2;
};

export const detectDeviceType = () => {
    // eslint-disable-next-line no-restricted-globals
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop';
};

export {
    objectAt,
    objectSet, // 安全设置多层对象的属性值
    arrayToTree,
    getUuid
};
